import { render, staticRenderFns } from "./ActiveOrderList.vue?vue&type=template&id=67a195cc&"
import script from "./ActiveOrderList.vue?vue&type=script&lang=ts&"
export * from "./ActiveOrderList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports